import useOrganization from '../../hooks/use-organization';
import OrganizationUsersPage from './organization';
import UsersR from './userList';

function UserPage() {
  const organizationInfo = useOrganization();

  return organizationInfo?.id ? <OrganizationUsersPage /> : <UsersR />;
}

export default UserPage;
